import React from "react";
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image, PDFViewer } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    viewer:{
      height: "100vh"
    },
    document:{
        display: "grip",

        // justifyContent: "center",
        // alignContent: "center"
    }
  ,
    page: {
    flexDirection: "column",
    padding: 40,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    height: 100,
    width: 100     
},
  title: {
    fontSize: 24,
    marginBottom: 20,
    textAlign: "center",
  },
  section: {
    marginBottom: 10,
  },
  label: {
    marginBottom: 5,
    fontWeight: "bold",
  },
  value: {
    marginBottom: 10,
  },
  signatureContainer: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  signatureLabel: {
    marginRight: 10,
    fontWeight: "bold",
  },
  signatureImage: {
    width: 200,
    height: 100,
    border: "1 solid #000",
  },
  button: {
    marginTop: 20,
    padding: 10,
    backgroundColor: "#007bff",
    color: "#fff",
    textAlign: "center",
  },
});

const SupportForm = ({ service }) => {
  console.log(service.signature)
  return (
    // <PDFViewer style={styles.viewer} className="PDFViewer">
    <Document style={styles.document}>
      <Page size="letter" style={styles.body}>
        <Text style={styles.title}>Servicio Técnico</Text>
        <View style={styles.section}>
          <Text style={styles.label}>Cliente:</Text>
          <Text style={styles.value}>{service.cliente}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.label}>Fecha:</Text>
          <Text style={styles.value}>{service.date}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.label}>Tipo de Servicio:</Text>
          <Text style={styles.value}>{service.service}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.label}>Observaciones:</Text>
          <Text style={styles.value}>{service.description}</Text>
        </View>

        <View style={styles.section}>
          <View style={styles.signatureContainer}>
            <Text style={styles.signatureLabel}>Firma:</Text>
            {service.signature ? (
              <Image src={service.signature} style={styles.signatureImage} />
            ) : (
              <Text>No se ha proporcionado una firma</Text>
            )}
          </View>
        </View>

        <Text style={styles.button}>Submit</Text>
      </Page>
    </Document>
    // </PDFViewer>
  );
};

export default SupportForm;
